import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAdminAuth } from '../../contexts/AdminAuthContext';
import AdminLogin from '../admin/AdminLogin';
import AdminDashboard from '../admin/AdminDashboard';
import ProtectedRoute from '../ProtectedRoute';

const AdminPage = () => {
    const { isAuthenticated } = useAdminAuth();

    return (
        <div style={{ minHeight: '100vh' }}>
            <Routes>
                {/* Route de login admin */}
                <Route 
                    path="/login" 
                    element={
                        !isAuthenticated ? (
                            <div style={{
                                minHeight: '100vh',
                                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                position: 'relative'
                            }}>
                                <AdminLogin />
                            </div>
                        ) : (
                            <Navigate to="/admin/dashboard" replace />
                        )
                    } 
                />
                
                {/* Route du dashboard admin protégée */}
                <Route 
                    path="/dashboard" 
                    element={
                        <ProtectedRoute>
                            <AdminDashboard />
                        </ProtectedRoute>
                    } 
                />
                
                {/* Redirection par défaut */}
                <Route 
                    path="/" 
                    element={
                        <Navigate to={isAuthenticated ? "/admin/dashboard" : "/admin/login"} replace />
                    } 
                />
                
                {/* Redirection pour routes inconnues */}
                <Route path="*" element={<Navigate to="/admin/" replace />} />
            </Routes>
        </div>
    );
};

export default AdminPage;
